<div class="floating-badge-wrapper" [class.position-inline]="position === 'inline'">
  <ng-content></ng-content>
  @if (isVisible) {
    <span
      class="floating-badge"
      [class.floating-badge--dot]="variant === 'dot'"
      [class.floating-badge--count]="variant === 'count'"
      [class.floating-badge--top-right]="position === 'top-right'"
      [class.floating-badge--top-left]="position === 'top-left'"
      [class.floating-badge--inline]="position === 'inline'">
      {{ displayValue }}
    </span>
  }
</div>
